import { cardDefinitionCatalog } from './card-definition-catalog'
import { validateCardInput } from './validate-card-input'

export const defaultCards = [
  {
    name: 'Running Activity',
    fields: {
      weeklyRunningFrequency: 5,
      averageRunDistance: 8.5,
      annualRaceParticipation: 3,
      runningGearPurchases: 12,
      runTrackingFrequency: 98,
    },
  },
  {
    name: 'Coffee Consumption',
    fields: {
      dailyCupsConsumed: 4,
      cafePurchaseFrequency: 22,
      specialtyBeveragePercentage: 35,
      homeBrewingEquipment: 6,
      beanOriginVariety: 14,
    },
  },
  {
    name: 'Restaurant Dining',
    fields: {
      monthlyDiningOutFrequency: 18,
      averageCheckAmount: 120.5,
      cuisineVariety: 15,
      reservationFrequency: 8,
      foodPhotographed: 30,
    },
  },
  {
    name: 'Streaming Media Consumption',
    fields: {
      dailyStreamingHours: 1.5,
      streamingServiceCount: 5,
      weeklyBingeWatchingFrequency: 1,
      contentGenreVariety: 8,
      newReleaseViewingPercentage: 65,
    },
  },
  {
    name: 'Technology Engagement',
    fields: {
      deviceOwnership: 18,
      techNewsConsumption: 12,
      deviceUpgradeCycle: 1.5,
      techTroubleshooting: 9,
      emergingTechInterest: 10,
    },
  },
  {
    name: 'Culinary Interests',
    fields: {
      cookbookCollection: 26,
      foodMediaConsumptionHours: 4.5,
      internationalCuisineExploration: 32,
      foodEventAttendance: 8,
      culinarySkillSelfRating: 7,
    },
  },
  {
    name: 'Fitness Interests',
    fields: {
      fitnessActivityVariety: 6,
      fitnessContentConsumption: 3.5,
      fitnessEquipmentInvestment: 2800,
      fitnessGoalCount: 4,
      fitnessAppUsage: 5,
    },
  },
  {
    name: 'Technology Upgrade Cycle',
    fields: {
      annualTechSpend: 9500,
      averageDeviceLifespan: 1.8,
      earlyAdopterPurchases: 7,
      techCategoryVariety: 12,
      lastGenerationPercentage: 15,
    },
  },
  {
    name: 'Gift Purchasing Behavior',
    fields: {
      annualGiftCount: 42,
      averageGiftValue: 175.5,
      giftPlanningTimeframe: 14,
      personalizationFrequency: 70,
      giftingOccasionVariety: 8,
    },
  },
  {
    name: 'Subscription Budget Allocation',
    fields: {
      activeSubscriptionCount: 18,
      monthlySubscriptionSpend: 320.75,
      subscriptionCategoryVariety: 7,
      subscriptionRetentionRate: 85,
      subscriptionUtilizationRate: 78,
    },
  },
  {
    name: 'Career Advancement Investments',
    fields: {
      careerTransitionStatus: 'Stable Position',
      professionalDevelopmentHours: 8.5,
      annualSkillTrainingSpend: 12000,
      professionalNetworkingFrequency: 15,
      careerContentConsumption: 7.5,
    },
  },
]
  .map(at => ({ name: at.name, ...at.fields }))
  .map(at => {
    const v = validateCardInput(at, cardDefinitionCatalog)
    if (v.isValid) {
      return at
    }

    throw new Error(`Bad card: ${JSON.stringify(v.errors)}`)
  })
